// 메뉴 타입에 해당하는 메뉴명 반환 (afterMenuName 우선)
export const findTargetMenuName = (menus, menuType) => {
  if (!menus.length || menuType === null || menuType === undefined) return "";

  const target = menus.find((menu) => menu.menuType === menuType);
  if (!target) return "";
  return target?.afterMenuName ? target.afterMenuName : target.beforeMenuName;
};

// 상품 이미지 렌더링 (JSON 파싱 후 이미지 URL 추출)
export const renderImage = (item) => {
  try {
    if (!item || !item.productImageUrl) throw new Error("EMPTY");
    const parsed = JSON.parse(item.productImageUrl);
    const url = Array.isArray(parsed) ? parsed[0] : parsed;
    if (!url) throw new Error("EMPTY_URL");
    return (
      <img
        src={imgHandler(url)}
        alt={item.name}
        onError={(e) => (e.target.src = "/img/icon_function_3.png")}
      />
    );
  } catch {
    return <img src="/img/icon_function_3.png" />;
  }
};

// 주문 전체 합계 금액 계산
export const calculateTotalPrice = (products) => {
  return products.reduce((total, group) => {
    return (
      total +
      group.products.reduce((sum, product) => {
        const { productPrice = 0, quantity = 1, options = [] } = product;
        const optionTotal = options.reduce(
          (optSum, opt) => optSum + (opt.price ?? 0) * (opt.qty ?? 1),
          0,
        );
        return sum + (productPrice + optionTotal) * quantity;
      }, 0)
    );
  }, 0);
};

// 단일 상품 기준 합계 금액 계산
export const calcPrice = (product) => {
  const { options = [], productPrice = 0, quantity = 1 } = product;

  const optionTotal = options.reduce((sum, opt) => sum + (opt.price ?? 0) * (opt.qty ?? 1), 0);

  return (productPrice + optionTotal) * quantity;
};

export const orderStatus = {
  ORDERED: "주문 접수",
  CONFIRMED: "판매자 확인",
  PREPARING: "상품 준비 중",
  SHIPPED: "배송 시작",
  DELIVERED: "배송 완료",
  CANCELLED: "취소 완료",
  RETURNED: "반품 완료",
  REFUNDED: "환불 완료",
  COMPLETED: "주문 완료",
};

export const renderProductInfo = (product, clickEvent = null) => {
  const { productName, options, quantity, totalPrice } = product;

  const optionText = options
    ?.map((opt) => {
      const priceText = opt.addPrice > 0 ? ` (+${formatNumber(opt.addPrice)}원)` : "";
      return `${opt.optionValue}${priceText}`;
    })
    .join(" / ");

  return (
    <div className="productInfo">
      <p onClick={clickEvent} className="productName">
        {productName}
      </p>
      <p>
        {optionText && `${optionText} × `}
        {quantity}개
      </p>
      <span>{formatNumber(totalPrice)}원</span>
    </div>
  );
};

// 주문 상태
export const status = {
  ORDERED: "주문 접수",
  CONFIRMED: "주문 확인",
  PREPARING: "상품 준비 중",
  SHIPPED: "배송 시작",
  DELIVERED: "배송 완료",
  COMPLETED: "완료 (정산 포함)",
  CANCELLED: "취소 완료",
  RETURNED: "반품 완료",
  REFUNDED: "환불 완료",
};

// 상품 상태
export const productStatus = {
  PENDING: "배송대기",
  IN_TRANSIT: "배송중",
  DELIVERED: "배송완료",
  CANCELLED: "주문취소",
  RETURNED: "반품완료",
};

// 택배사 목록 정의
export const couriers = [
  { label: "CJ대한통운", value: "CJ" },
  { label: "한진택배", value: "HANJIN" },
  { label: "로젠택배", value: "LOGEN" },
  { label: "우체국택배", value: "POST" },
  { label: "롯데택배", value: "LOTTE" },
  { label: "쿠팡로지스틱스", value: "COUPANG" },
  { label: "경동택배", value: "KDEXP" },
  { label: "일양로지스틱스", value: "ILYANG" },
  { label: "천일택배", value: "CHUNIL" },
  { label: "대신택배", value: "DAESIN" },
  { label: "합동택배", value: "HAPDONG" },
];

// 택배사 이름 반환
export const findCourierName = (courierCodeOrLabel) => {
  if (!courierCodeOrLabel) return "";

  const found = couriers.find(
    (c) => c.label === courierCodeOrLabel || c.value === courierCodeOrLabel,
  );

  return found?.label || courierCodeOrLabel;
};
